import { DownloadIcon } from 'lucide-react'
import { apiURL } from '../../../../utilities/URLs'
import { account } from '../../../../classes/Account'
import { useEffect, useState } from 'react'
import { refreshAccessToken } from '../../../../utilities/extensions'
import { useNavigate } from 'react-router-dom'

const states = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana',
  'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts',
  'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska',
  'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
  'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah',
  'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
]

export default function Download8821({ applicationId }) {
  const navigate = useNavigate()

  const [checking8821, setChecking8821] = useState(true)
  const [has8821, setHas8821] = useState(false)
  const [name, setName] = useState('')
  const [title, setTitle] = useState('')
  const [ein, setEIN] = useState('')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [zip, setZip] = useState('')

  const isFormValid = title && ein.length === 10 && address && city && state && zip.length === 5

  const formatEIN = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 9)
    if (digits.length <= 2) return digits
    return `${digits.slice(0, 2)}-${digits.slice(2)}`
  }

  const handleDownload8821 = async () => {
    const response8821 = await fetch(`${apiURL}/api/applications/${applicationId}/8821/`, {
      method: 'POST',
      headers: {
        'Authorization': account.accessToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name,
        personalName: account.name,
        phone: account.phone,
        title,
        ein,
        address,
        city,
        state,
        zip
      })
    })

    if (response8821.ok) {
      const blob = await response8821.blob()
      const blobUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.download = 'Form8821.pdf'
      document.body.appendChild(link)
      link.click()
      link.remove()

      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000)
    }
  }

  useEffect(() => {
    const handleCheck8821 = async () => {
      const checkResponse = await fetch(`${apiURL}/api/applications/${applicationId}/8821/`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const checkData = await checkResponse.json()
      if(checkData.response.error) {
        if(checkData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleCheck8821() : navigate('/', { state: { expired: true } })
        } else
          console.error(checkData.response.error)
      } else
        setHas8821(checkData.response.has8821)

      setChecking8821(false)
    }

    handleCheck8821()
  }, [])

  return (
    <div className='w-full mx-auto p-6 bg-white rounded-lg shadow-lg'>
      {checking8821 ? (
        <div className='flex flex-row items-center justify-center gap-2 mt-5'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
          <p className='text-md text-center'>Loading 8821...</p>
        </div>
      ) : (
        <div>
          <h2 className='text-2xl font-semibold mb-4 text-center text-gray-800'>{has8821 ? 'Please click the button below to download your 8821' : 'Please fill out the information below to download your 8821 Form'}</h2>
          <p className='text-center'>Make sure to print, wet-sign, scan, and upload the document here</p>
          {has8821 ? (
            <button
              onClick={handleDownload8821}
              className='w-full flex items-center justify-center gap-2 rounded-md px-4 py-3 text-white mt-6 transition bg-ertc-primary hover:bg-ertc-primary-dark'
            >
              <DownloadIcon size={20} />
              Download 8821
            </button>
          ) : (
            <div className='flex flex-col gap-4'>
              <input
                className='border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500'
                placeholder='Business Name'
                value={name}
                onChange={e => setName(e.target.value)}
              />
              <input
                className='border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500'
                placeholder='Title'
                value={title}
                onChange={e => setTitle(e.target.value)}
              />
              <input
                className='border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500'
                placeholder='EIN (e.g., 12-3456789)'
                value={ein}
                onChange={e => setEIN(formatEIN(e.target.value))}
              />
              <input
                className='border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500'
                placeholder='Business Address'
                value={address}
                onChange={e => setAddress(e.target.value)}
              />
              <div className='w-full flex max-sm:flex-col gap-4'>
                <input
                  className='w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500'
                  placeholder='City'
                  value={city}
                  onChange={e => setCity(e.target.value)}
                />
                <select
                  className='w-full border border-gray-300 rounded-md p-3 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500'
                  value={state}
                  onChange={e => setState(e.target.value)}
                >
                  <option value=''>Select State</option>
                  {states.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
                <input
                  className='w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500'
                  placeholder='Zip'
                  value={zip}
                  maxLength={5}
                  onChange={e => setZip(e.target.value.replace(/\D/g, '').slice(0, 5))}
                />
              </div>

              <button
                onClick={handleDownload8821}
                disabled={!isFormValid}
                className={`flex items-center justify-center gap-2 rounded-md px-4 py-3 text-white mt-6 transition ${
                  isFormValid
                    ? 'bg-ertc-primary hover:bg-ertc-primary-dark'
                    : 'bg-gray-400 cursor-not-allowed'
                }`}
              >
                <DownloadIcon size={20} />
                Download 8821
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
